<template lang="pug">
  b-container(fluid)
    b-card.shadow(v-if="showLLMConfig" )
      h5 LLM
      b-form-group(label-cols="auto", label="Activar LLM", label-class="py-0" )
        b-form-checkbox(switch, v-model="account_config_v2.custom_llm_enabled") {{account_config_v2.custom_llm_enabled ? 'Activado' : 'Desactivado'}}
      b-form-group(label-cols="auto", label="Precisión de búsqueda semántica para contexto")
        number-input(v-model.number="account_config_v2.custom_llm_confidence", controls, inline, center, placeholder="0", :min="0", :max="1", :step="0.1" )
      b-form-group(label="Prompt con contexto")
        b-form-textarea(:placeholder="llmPromptPlaceholder", v-model="account_config_v2.custom_llm_prompt")
      b-form-group(label-cols="auto", label="Usar LLM cuando no se tenga contexto", label-class="py-0").d-flex.align-items-center
        alert-circle-icon.icon-sm.mr-2.hover-primary.pointer(
          v-b-tooltip.hover="switchLLMNoContextText"
        )      
        b-form-checkbox.ml-1(switch, inline, center, v-model="account_config_v2.use_llm_on_no_context") {{ account_config_v2.use_llm_on_no_context ? 'Activada' : 'Desactivada' }}        
      b-form-group(label="Prompt sin contexto")
        b-form-textarea(:placeholder="llmPromptNoContextPlaceholder", v-model="account_config_v2.custom_llm_prompt_no_context")
      h5(v-b-toggle.advanced-settings) Configuración avanzada
        chevron-down-icon.icon-md.ml-2
      b-collapse(id="advanced-settings" class="mt-2")
        b-form-group(label-cols="auto", label="Búsqueda de documento:", label-class="py-0")
          .d-flex.align-items-center
            b-form-checkbox.ml-1(
              switch,
              v-model="account_config_v2.document_search"
            ) {{ account_config_v2.document_search ? 'Activada' : 'Desactivada' }}
        b-form-group(
          label-cols="auto",
          label="Temperature"
        )
          .d-flex.align-items-center
            alert-circle-icon.icon-sm.mr-2.hover-primary.pointer(
              v-b-tooltip.hover="temperatureText"
            )
            number-input(
              v-model.number="account_config_v2.temperature",
              controls,
              inline,
              center,
              placeholder="0.2",
              :min="0",
              :max="1",
              :step="0.01"
            )
        b-form-group(
          label-cols="auto",
          label="top_p"
        )
          .d-flex.align-items-center
            alert-circle-icon.icon-sm.mr-2.hover-primary.pointer(
              v-b-tooltip.hover="topPText"
            )
            number-input(
              v-model.number="account_config_v2.top_p",
              controls,
              inline,
              center,
              placeholder="0.9",
              :min="0",
              :max="1",
              :step="0.01"
            )
        b-form-group(
          label-cols="auto",
          label="top_k"
        )
          .d-flex.align-items-center
            alert-circle-icon.icon-sm.mr-2.hover-primary.pointer(
              v-b-tooltip.hover="topKText"
            )
            number-input(
              v-model.number="account_config_v2.top_k",
              controls,
              inline,
              center,
              placeholder="20",
              :min="0",
              :step="1"
            )
    hr
    //b-card.shadow
      h5 Transformación de entidades
      b-form-group(label-cols="auto", label="Transformar entidad", label-class="py-0" )
        b-form-checkbox(switch, v-model="account_config_v2.entity_transformer_enabled") {{account_config_v2.entity_transformer_enabled ? 'Activado' : 'Desactivado'}}
      b-form-group(label="Entidad")
        b-form-select(v-model="account_config_v2.entity_transformer_id")
          option(:value="null", disabled) --Selecciona entidad--
          option(v-for="({entity_id, name}) in entities", :key="entity_id", :value="entity_id") {{name}}
    b-card.shadow
      h5.mb-3 Búsqueda semántica (preguntas en entrenamiento)
      //b-form-group(label-cols="auto", label="Activar Chat GPT", label-class="py-0" )
        b-form-checkbox(switch, v-model="account_config_v2.chat_gpt_enabled") {{account_config_v2.chat_gpt_enabled ? 'Activado' : 'Desactivado'}}
      //b-form-group(label-cols="auto", label="Usar dominio personalizado", label-class="py-0" )
        b-form-checkbox(switch, v-model="account_config_v2.use_custom_domain") {{account_config_v2.use_custom_domain ? 'Si' : 'No'}}
      //b-form-group(label-cols="auto", label="Librar administradores de casos", label-class="py-0" )
        b-form-checkbox(switch, v-model="account_config_v2.release_admin_cases") {{account_config_v2.release_admin_cases ? 'Liberar' : 'No liberar'}}
      b-form-group(label-cols="auto", label="Precisión")
        number-input(
          v-model.number="account_config_v2.semantic_confidence",
          controls,
          inline,
          center,
          placeholder="0",
          :min="0",
          :max="1",
          :step="0.01"
        )
      h5 Búsqueda por similitud de caracteres
      b-form-group(label-cols="auto", label="Activar similitud de caracteres:")
        .d-flex.align-items-center.mt-2
          span.mr-2 {{ account_config_v2.char_match_enabled ? 'Sí' : 'No' }}
          b-form-checkbox(
            v-model="account_config_v2.char_match_enabled",
            switch
          )
      b-form-group(label-cols="auto", label="Precisión de similitud de caracteres:")
        number-input(
          v-model.number="account_config_v2.char_match_confidence",
          controls,
          inline,
          center,
          placeholder="0",
          :min="0",
          :max="1",
          :step="0.01"
        )
    hr
    b-card.shadow
      h5 Llamadas
      b-form-group(label="Mensaje de inicio")
        b-form-textarea(placeholder="Whatsapp aprobado", v-model="account_config_v2.voip_start_message")
      b-form-group(label="Bloque sin agentes para llamada")
        block-connector(:next_block_id="account_config_v2.voip_not_admins_block", @change="data => { account_config_v2.voip_not_admins_block = data.next_block_id }")
        template(#description)
          .text-secondary La llamada se redirigirá al bloque cuando no hayan agentes disponibles para atenderla.
          b-link.text-danger.text-sm(@click="account_config_v2.voip_not_admins_block = null") Borrar bloque
    hr
    b-card.shadow(v-if="account_config_v2.no_answer")
      h5 Mensaje por defecto para cuando el bot no tiene respuesta
      b-form-group(label="Mensaje")
        b-form-input(placeholder="Mensaje", v-model="account_config_v2.no_answer.value" )
      b-form-group(label="Conexión con bloque")
        block-connector(:next_block_id="account_config_v2.no_answer.next_block_id", @change="data => { account_config_v2.no_answer.next_block_id = data.next_block_id }")
        template(#description)
          b-link.text-danger.text-sm(@click="account_config_v2.no_answer.next_block_id = null") Borrar bloque
    b-button(variant="primary", block, @click="updateConfigurationV2", :disabled="loading")
      span Guardar
      b-spinner.ml-2(small, type="grow", variant="light", v-if="loading")
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'

const organizationController = createNamespacedHelpers('organization')
const accountController = createNamespacedHelpers('account')
const entityController = createNamespacedHelpers('entity')

export default {
  name: 'IAConfiguration',
  data() {
    return {
      loading: false,
      switchLLMNoContextText: 'Si se encuentrá activado cuando no se haga match con conocimiento (Entrenamiento) se responderá usando el "Prompt sin contexto", en caso contrario se enviará a la configuración de "Mensajes para cuando el chatbot no tiene respuesta"',
      llmPromptPlaceholder: 'Ejemplo: Responde al INPUT considerando lo siguiente: Responde en el idioma del INPUT de la forma más breve posible. Si existe CONTEXT, utilízalo para responder. Si algún INPUT no tiene sentido o no es coherente, explica por qué en lugar de decir que no es correcto. Si algo no esta en el contexto, no des información falsa.',
      llmPromptNoContextPlaceholder: 'Ejemplo: Responde al INPUT considerando lo siguiente: Responde en el idioma del INPUT de la forma más breve posible. Si existe CONTEXT, utilízalo para responder. Si algún INPUT no tiene sentido o no es coherente, explica por qué en lugar de decir que no es correcto. Si algo no esta en el contexto, no des información falsa.',
      temperatureText: `Controla la creatividad del modelo.\n\n Valores más
      altos (por ejemplo, 0.8) hacen que las respuestas sean más creativas pero
      posiblemente menos coherentes. Valores más bajos (por ejemplo, 0.2) tienden
      a generar respuestas más precisas pero menos creativas.`,
      topPText: `Regula la diversidad de las respuestas.\n\n Valores más altos
      (por ejemplo, 0.9) pueden hacer que el texto sea más diverso, mientras que
      valores más bajos (por ejemplo, 0.3) tienden a generar texto más
      selectivo.`,
      topKText: `Limita el número de opciones de palabras sugeridas.\n\n Determina
      cuántas opciones de palabras diferentes se considerarán al generar la
      respuesta. Un valor más alto (por ejemplo, 50) incluirá más opciones,
      mientras que un valor más bajo (por ejemplo, 10) limitará las opciones a
      las más probables.`
    }
  },
  computed: {
    ...organizationController.mapState({
      plugins: state => state.plugins
    }),
    ...entityController.mapState({
      entities: state => state.entities
    }),
    ...accountController.mapState({
      admins: (state) => state.admins,
      account_config_v2: (state) => state.account_configuration_v2
    }),
    showLLMConfig() {
      const exist = this.plugins.find(({name}) => name === 'LLM')
      return !!exist
    }
  },
  methods: {
    ...mapActions([
      'entity/all',
      'account/get_configuration_v2',
      'account/update_configuration_v2'
    ]),
    getEntities () {
      this['entity/all']({
        account_id: this.$route.params.account_id,
        callback: res => {
          if (res.error) this.$message.error(res.error)
        }
      })
    },
    getConfigurationV2() {
      this.loading = true
      this['account/get_configuration_v2']({
        account_id: this.$route.params.account_id,
        callback: (res) => {
          this.loading = false
          if (res.error) this.$message.error(res.error)
        }
      })
    },
    updateConfigurationV2() {
      this.loading = true
      const self = this

      this['account/update_configuration_v2']({
        account_id: self.$route.params.account_id,
        ...self.account_config_v2,
        callback: (res) => {
          self.loading = false

          if (res.error) return self.$message.error(res.error)

          self.$message.success('Configuración actualizada')
        }
      })
    },
  },
  mounted() {
    this.getEntities()
    this.getConfigurationV2()
  }
}
</script>

<style scoped>

</style>